import { useMemo } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { StateLoginsTable } from '../components/StateLoginsTable'

export function StepNewLoginWizard() {
  const { state } = useOnboarding()

  const deferredRows = useMemo(
    () => state.stateLogins.filter((r) => r.pendingLoginWizard),
    [state.stateLogins],
  )

  return (
    <Stack spacing={2.5}>
      <Box>
        <Typography
          component="h2"
          sx={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.025em', color: '#0f172a' }}
        >
          New Login Wizard
        </Typography>
        <Typography
          component="p"
          sx={{
            mt: 1,
            maxWidth: { xs: '56rem', lg: 'none' },
            fontSize: 14,
            lineHeight: 1.625,
            color: '#475569',
          }}
        >
          Complete username and password for each state you deferred on SL Logins. These credentials
          are required before you continue.
        </Typography>
      </Box>

      <StateLoginsTable rows={deferredRows} mode="wizard" />
    </Stack>
  )
}
